module.exports = __webpack_public_path__ + "static/media/Mission Farewell - Hexagon.aca88b0d.png";